import {motion} from 'framer-motion';
import Card from "../../shared/Card";
import GeneralContext from '../../../context/GeneralContext';
import { useContext, useState } from 'react';
import TextInputHorizontalTag from '../../shared/TextInputHorizontalTag';
import ButtonFunction from '../../shared/ButtonFunction';
import { IoIosSend } from "react-icons/io";
import { fetchBody } from '../../../utils/fetch';

function AddBenefit() {

    const { changeCurrentMenu, changeModalTitle, changeModalText, changeModalType } = useContext(GeneralContext);

    const [ benefitTitle, setBenefitTitle] = useState('');
    const changeBenefitTitle = (e) => {
        setBenefitTitle(e.target.value);
    }

    const [ benefitValue, setBenefitValue ] = useState('');
    const changeBenefitValue = (e) => {
        setBenefitValue(e.target.value);
    }

    const verifyAndSend = async () => {

        let alertMessage = '';

        let validTitle = true;
        if (benefitTitle.length < 4) {
            alertMessage = 'El título no puede estar vacío o tener menos de cuatro caracteres\n';
            validTitle = false;
        }

        let validValue = true;
        if (benefitValue < 0 || benefitValue > 365) {
            alertMessage = 'El valor debe ser mayor a cero y menos al máximo de puntos\n';
            validValue = false;
        }

        if (alertMessage !== '') {
            const modal = document.getElementById("myModal");
            changeModalTitle('Error en el proceso');
            changeModalText(alertMessage);
            changeModalType('alert');
            modal.style.display = "block";
        }

        if (validTitle && validValue) {

            const data = {
                title: benefitTitle,
                value: benefitValue
            }

            const response = await fetchBody('benefits/', 'POST', data);

            if (response.success) {
                const card = document.getElementById('addBenefitCard');
                card.style.animation = 'vanish-up 0.5s';
                card.addEventListener("animationend", function finAnimacion () {
                    card.removeEventListener("animationend", finAnimacion);
                    card.style.display = 'none';
                    changeCurrentMenu('benefit-list');
                });
    
            }
        }

    }

  return (
    <motion.div
        id='addBenefitCard'
        key='adminAddUser'
        initial={{opacity: 0, x: -1000}}
        animate={{opacity: 1, x: 0}}
        exit={{opacity: 0, x: -1000, transition:{duration: 0.5, delay: 0}}}
        transition={{duration: 0.5}}>
            <Card hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'manage-benefits'}>
                <h2>Agregar Beneficio</h2>
                <TextInputHorizontalTag label='Título' inputClass='adminInput' changeEvent={changeBenefitTitle} />
                <TextInputHorizontalTag label='Valor' type='number' inputClass='adminInput' changeEvent={changeBenefitValue} />
                <br />
            <ButtonFunction buttonFunction={verifyAndSend} buttonClass='adminButton' ><IoIosSend/>Agregar</ButtonFunction>
            </Card>
    </motion.div>
  )
}

export default AddBenefit